import { INITIALIZE_AUTH } from '../actions/constants/ActionTypes';
const initialState = {
  user: {},
  portal: {},
  gates: []
};

const auth = (state = initialState, action) => {
  const {
    type,
    payload
  } = action;

  switch (type) {
    case INITIALIZE_AUTH:
      return {
        user: payload.user,
        gates: payload.gates,
        portal: payload.portal
      };

    default:
      return state;
  }
};

export default auth;